import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none" fillRule="evenodd"><circle fill="#FF5252" cx="8" cy="8" r="8" /><path fill="#FFF" fillRule="nonzero" d="M6.666 11.333V7.42h.038l2.904 3.913h1.37V4.667H9.334v3.876h-.038l-2.89-3.876H5.022v6.666z" /></g></svg>);